import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IHeaderGroupAngularComp } from 'ag-grid-angular';
import { IHeaderGroupParams } from 'ag-grid-community';

@Component({
  selector: 'app-aggrid-group-header',
  standalone: true,
  imports: [
    CommonModule,
  ],
  templateUrl: './aggrid-group-header.component.html',
  styleUrl: './aggrid-group-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AggridGroupHeaderComponent implements IHeaderGroupAngularComp {
  public params: IHeaderGroupParams;
  public isExpanded = true;

  agInit(params: IHeaderGroupParams): void {
    this.params = params;
    this.isExpanded = this.params?.columnGroup?.isExpanded();
  }

  onFilterClicked() {
  }

  expandOrCollapse() {
    this.isExpanded = !this.isExpanded;
    this.params.setExpanded(this.isExpanded);
  }
}
